import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Bonjour, Je suis{" "}
            <span className="brown">Laurent Junot RAKOTONDRABE </span>
            habitant à <span className="brown"> Antananarivo, Madagascar.</span>
            <br />
            Je suis récemment diplômé en Informatique Risque et Décisions.
            <br />
            J'ai pu terminée mon parcours en Licence à l'Université E.S.M.I.A
            <br />
            <br />A part travaillé en tant que développeur et analyste en
            informatique
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Je partage des connaissances en langue Anglaise
              dans mon groupe{" "}
              <a
                href="https://web.facebook.com/groups/learn.english.from.facebook"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>
            <li className="about-activity">
              <ImPointRight /> Suivre des documentaires
            </li>
            <li className="about-activity">
              <ImPointRight /> Auto-Formations
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
